export enum SubscriptionState {
  Trialing = "Trialing",
  Active = "Active",
  ReadOnly = "ReadOnly",
  Cancelled = "Cancelled",
}
